import { useState, useEffect } from "react";

function useChangeTitle(initialTitle) {
  const [documentTitle, setDocumentTitle] = useState(initialTitle);
  
  useEffect(() => {
    const prevTitle = document.title;
    
    document.title = documentTitle; 

    return () => {
      document.title = prevTitle;
    }
  }, [documentTitle]);

  return [documentTitle, setDocumentTitle];
}

export default useChangeTitle;